import React, { ReactNode } from 'react';
import styles from './utils.module.scss'

export const RequiredAsterisk = () => (<span className={styles.required}>*</span>);

export const SelectOne = () => (<option value=''>- Select One -</option>);

export const Modal = ({ children }: { children: ReactNode }) => (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.modalContent}>
          {children}
        </div>
      </div>
    </div>
);
